"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ProductBundle = /** @class */ (function (_super) {
    __extends(ProductBundle, _super);
    function ProductBundle(props) {
        var _a, _b, _c, _d, _e;
        var _this = _super.call(this, props) || this;
        _this.state = {
            bundleId: (_e = (_d = (_c = (_b = (_a = props) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.metafields) === null || _c === void 0 ? void 0 : _c.custom) === null || _d === void 0 ? void 0 : _d.bundle_id, (_e !== null && _e !== void 0 ? _e : null))
        };
        return _this;
    }
    ProductBundle.prototype.render = function () {
        var _a, _b;
        return (((_a = this.state) === null || _a === void 0 ? void 0 : _a.bundleId) && (React.createElement("div", { className: "w-full flex flex-wrap" },
            React.createElement("div", { class: "rbrBundleBuilder", "bundle-id": (_b = this.state) === null || _b === void 0 ? void 0 : _b.bundleId }))));
    };
    return ProductBundle;
}(React.PureComponent));
exports.ProductBundle = ProductBundle;
